import { render, staticRenderFns } from "./DetailArticle.vue?vue&type=template&id=474157ae&scoped=true"
import script from "./DetailArticle.vue?vue&type=script&lang=js"
export * from "./DetailArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474157ae",
  null
  
)

export default component.exports